import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  TEMPLATE_TICKET,
  TEMPLATE_TICKET_FIELDS,
  SERVICE_REQ,
  SERVICE_REQ_FIELDS,
  EXTERNAL_FIELDS,
  TEMPLATE_T_DEL_STATE,
  TEMPLATE_T_ADD_EDIT_STATE,
  TEMPLATE_T_FIELDS_DEL_STATE,
  TEMPLATE_T_FIELDS_ADD_EDIT_STATE,
  SERVICE_REQ_DEL_STATE,
  SERVICE_REQ_ADD_EDIT_STATE,
  SERVICE_REQ_FIELDS_DEL_STATE,
  SERVICE_REQ_FIELDS_ADD_EDIT_STATE,
  EXTERNAL_FIELDS_DEL_STATE,
  EXTERNAL_FIELDS_ADD_EDIT_STATE,
  FIELDS_TYPE,
} = STATE_IDENTIFIER;
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [FIELDS_TYPE]: [],
  [TEMPLATE_TICKET]: [],
  [TEMPLATE_T_DEL_STATE]: IResponseState.PENDING,
  [TEMPLATE_T_ADD_EDIT_STATE]: IResponseState.PENDING,

  [TEMPLATE_TICKET_FIELDS]: [],
  [TEMPLATE_T_FIELDS_DEL_STATE]: IResponseState.PENDING,
  [TEMPLATE_T_FIELDS_ADD_EDIT_STATE]: IResponseState.PENDING,

  [SERVICE_REQ]: [],
  [SERVICE_REQ_DEL_STATE]: IResponseState.PENDING,
  [SERVICE_REQ_ADD_EDIT_STATE]: IResponseState.PENDING,

  [SERVICE_REQ_FIELDS]: [],
  [SERVICE_REQ_FIELDS_DEL_STATE]: IResponseState.PENDING,
  [SERVICE_REQ_FIELDS_ADD_EDIT_STATE]: IResponseState.PENDING,

  [EXTERNAL_FIELDS]: [],
  [EXTERNAL_FIELDS_DEL_STATE]: IResponseState.PENDING,
  [EXTERNAL_FIELDS_ADD_EDIT_STATE]: IResponseState.PENDING,
};
